import script from "./WmsAgreementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WmsAgreementModal.vue?vue&type=script&setup=true&lang=js"

import "./WmsAgreementModal.vue?vue&type=style&index=0&id=648f56f4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648f56f4"]])

export default __exports__